import Button from "Components/button";
import ProgressOverlay from "Components/progressOverlay";
import classNames from "classnames";
import isUndefined from "lodash/isUndefined";
import React from "react";
import locale from "./welcome.locale";
import styles from "./Welcome.module.css";
export default function Welcome(props) {
    return (React.createElement("div", { className: classNames("stretched-to-fit", props.className) },
        React.createElement(ProgressOverlay, { show: props.inProgress },
            React.createElement("div", { className: styles["welcome-container"] },
                React.createElement("h1", { className: "font-bold line-height-1" }, locale.WELCOME),
                React.createElement("div", { className: classNames("text-muted font-h5", isUndefined(props.workSpacesCount) && "invisible") }, props.workSpacesCount ? locale.DESCRIPTION_NOT_EMPTY_WORKSPACES : locale.DESCRIPTION),
                props.canEdit && (React.createElement("div", { className: styles["btn-container"] },
                    React.createElement(Button, { className: "btn-primary", onClick: props.onOpenWorkSpaceCreatorPanel },
                        React.createElement("i", { className: "icon-add mr-0_5" }),
                        locale.ADD_WORKSPACE)))))));
}
